import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, TextField, Button, Box, Typography, FormControlLabel, Radio, RadioGroup, useMediaQuery } from '@mui/material';
import { Globe } from 'lucide-react';
import BottomSheetDialog from './mobile/mobile-bottom-sheet';
import theme from '../../util/theme/theme';

interface AddCompanyPopupProps {
    open: boolean;
    onClose: () => void;
    onConfirm: (name: string, amount: string, enabled: boolean) => void;
}

const AddCompanyPopup: React.FC<AddCompanyPopupProps> = ({ open, onClose, onConfirm }) => {
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const [name, setName] = useState('');
    const [amount, setAmount] = useState('');
    const [errorName, setErrorName] = useState(false);

    const handleConfirm = () => {
        setErrorName(!name);
        if (name && amount) {
            onConfirm(name, amount, true);
            setName('');
            setAmount('');
        }
    };

    const handleClose = () => {
        setName('');
        setAmount('');
        setErrorName(false);
        onClose();
    };

    const content = (
        <>
            <DialogTitle sx={{ fontWeight: 700, fontSize: 22, pb: 1 }}>Add New Company</DialogTitle>
            <DialogContent sx={{ pt: 1 }}>
                <Box mb={0.25}>
                    <Typography fontSize={14} color='var(--color-text-muted)'>
                        Company Name <span style={{ color: '#F44336' }}>*</span>
                    </Typography>
                    <TextField
                        fullWidth
                        size="small"
                        placeholder="Enter Company Name"
                        value={name}
                        onChange={e => setName(e.target.value)}
                        error={errorName}
                        sx={{ background: 'var(--color-page-background)', borderRadius: 2 }}
                    />
                </Box>
                <Box display="flex" alignItems="center" gap={1} mb={2} color="var(--color-text-muted)">
                    <Globe size={13}/><Typography fontSize={12}>www.{name || 'companywebsite'}.com</Typography>
                </Box>
            </DialogContent>
            <DialogActions sx={{ justifyContent: 'space-between', px: 3, pb: 2 }}>
                <Button onClick={handleClose} variant="contained" sx={{ background: 'var(--color-container-background)', color: 'var(--color-text-muted)', boxShadow: 'none', borderRadius: 2, fontWeight: 600, width: 120, '&:hover': { background: 'var(--color-container-background)' } }}>
                    Cancel
                </Button>
                <Button onClick={handleConfirm} variant="contained" sx={{ background: 'var(--color-primary)', color: '#fff', boxShadow: 'none', borderRadius: 2, fontWeight: 600, width: 120, '&:hover': { background: 'var(--color-primary)' } }}>
                    Add Company
                </Button>
            </DialogActions>
        </>
    );

    return isMobile ? (
        <BottomSheetDialog open={open} onClose={handleClose} fitContent>
            {content}
        </BottomSheetDialog>
    ) : (
        <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm" PaperProps={{ sx: { borderRadius: 3 } }}>
            {content}
        </Dialog>
    );
};

export default AddCompanyPopup;
